import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Globals } from 'app/_globals';
import { FileService } from 'app/_services/file.service';
import { SiteWorkOrderProceduresService } from 'app/_services/site-work-order-procedures.service';
import { SiteService } from 'app/_services/site.service';
import { ProcedureOemCompetencyDto, ProcedureOemCompetencyService } from 'app/_services/procedure-oem-competency.service';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SiteFormsService } from 'app/_services/site-forms.service';
import { COMPETENCY_CATEGORY_LABELS } from 'app/_models/competency.model';
import { EditCompetenciesComponent } from 'app/shared-pages/work-order/components/edit-competencies/edit-competencies.component';
import { SortEvent } from 'primeng/api';
import { Pagination } from 'app/_models/pagination.model';
import { TextFilterBoxComponent } from 'app/shared-pages/dashboard/components/text-filter-box/text-filter-box.component';

@Component({
  selector: 'app-site-work-order-procedures',
  templateUrl: './site-work-order-procedures.component.html',
})
export class SiteWorkOrderProceduresComponent implements OnInit {
  private readonly competencyDisplayItemLimit = 3;

  public isOEMView: boolean = false;

  private selectedSiteId: any;
  public selectedProcedure: any;
  public selectedOem: any;
  public procedures: any[] = [];
  public oemProcedures: any[] = [];
  public oems: any[] = [];
  public selectedSite: any;
  public showOEMProceduresModal: boolean = false;

  // pagination
  public pageSizes: any = environment.pageSizes;
  public pagination: any;
  public paginationOem: any;
  @ViewChild('paginator') paginator;

  // Sorting and Filtering
  defaultSortField = 'name';
  selectedSort = [ this.defaultSortField + ',asc' ];

  public isFilterLoading: boolean;
  private filters = [
    { key: 'idFilter', value: '' },
    { key: 'nameFilter', value: '' },
    { key: 'descriptionFilter', value: '' },
  ];
  private isResettingFilters = false;
  @ViewChildren(TextFilterBoxComponent) filterBoxes: QueryList<TextFilterBoxComponent>;

  public saveInProgress = false;

  public selectedDocuments: any[] = [];
  public isViewProcedureDocumentsModalShown: boolean;
  public isAddDocumentsToProcedureModalShown: boolean;
  public allowCompulsoryCheckOnSiteForm: boolean;
  public allowCompulsoryCheckOffSiteForm: boolean;
  public allowWorkOrderScheduling: boolean;
  public allowAssetScheduling: boolean;

  public showOEMProcedureSettingsModal: boolean = false;
  public updateSiteOEMSettingsForm: FormGroup;
  public siteFormsOptions: any[] = [];

  public oemProcedureCompetencies: ProcedureOemCompetencyDto[] = [];
  public oemProcedureCompetencyCards: any[] = [];

  constructor(
    private globals: Globals,
    private siteService: SiteService,
    private procedureService: SiteWorkOrderProceduresService,
    private fileService: FileService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private siteFormService: SiteFormsService,
    private procedureOemCompetencyService: ProcedureOemCompetencyService,
    private modalService: NgbModal,
    public fb: FormBuilder,
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.selectedSiteId = params.id;
    });
    this.updateSiteOEMSettingsForm = fb.group({
      minPartySize: new FormControl(1, [Validators.required, Validators.min(1), Validators.max(30)]),
      siteFormCheckOn: new FormControl(),
      siteFormCheckOff: new FormControl(),
      preapproved: new FormControl(),
    });
  }

  //
  // Page Load
  //

  ngOnInit(): void {
    this.siteService.getSiteById(this.selectedSiteId).subscribe((data: any) => {
      this.selectedSite = data;
      this.allowCompulsoryCheckOnSiteForm = this.selectedSite.siteOwner.siteOwnerUser.allowCompulsoryCheckOnSiteForm;
      this.allowCompulsoryCheckOffSiteForm = this.selectedSite.siteOwner.siteOwnerUser.allowCompulsoryCheckOffSiteForm;
      this.allowWorkOrderScheduling = this.selectedSite.siteOwner.siteOwnerUser.allowWorkOrderScheduling;
      this.allowAssetScheduling = this.selectedSite.siteOwner.siteOwnerUser.allowAssetScheduling;
    });
    this.resetPagination();
    this.getOEMListBySite();
    this.getAllSiteForms();
    this.loadOemProcedureCompetencies();
  }

  private getOEMListBySite(){
    this.procedureService.getOemListBySite(this.selectedSiteId).subscribe((data: any) => {
      this.oems = data.body;
    });
  }

  private getAllWorkerOrderProcedures() {
    this.procedureService.getAllWorkOrderProceduresBySite(this.selectedSiteId, this.pagination, this.selectedSort, this.filters).subscribe((data: any) => {
      this.procedures = (data.body || []).map((procedure) => this.decorateProcedureCompetencies(procedure));
      this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
      this.isFilterLoading = false;
    });
  }

  //
  // Table actions
  //

  public paginate(event: any): void {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    if(this.showOEMProceduresModal){
      this.getOEMProcedures();
    } else {
      this.getAllWorkerOrderProcedures();
    }
  }

  private resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
    this.goToFirstPage();
    if(this.showOEMProceduresModal){
      this.getOEMProcedures();
    } else {
      this.getAllWorkerOrderProcedures();
    }

  }

  public customSort(sort: SortEvent) {
    let sortDirection: String = 'asc';

    if (sort.order === -1) {
      sortDirection = 'desc';
    }
    this.selectedSort = [ sort.field + ',' + sortDirection ];

    this.goToFirstPage();

    if (this.showOEMProceduresModal){
      this.getOEMProcedures();
    } else {
      this.getAllWorkerOrderProcedures();
    }
  }

  private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }

  public onFilterTextChanged(filterText: string, filterField: string){
    if (this.isResettingFilters) {
      return;
    }
    this.isFilterLoading = true;

    if (filterField === 'idFilter') {
      filterText = filterText.replace(/PRC/gi, '');
    }

    this.filters.find(filter => filter.key === filterField).value = filterText;

    this.goToFirstPage();

    if (this.showOEMProceduresModal){
      this.getOEMProcedures();
    } else {
      this.getAllWorkerOrderProcedures();
    }
  }

  private resetFilters(): void {
    this.isResettingFilters = true;
    this.filters.forEach(filter => filter.value = '');
    if (this.filterBoxes) {
      this.filterBoxes.forEach(box => box.clearFilter());
    }
    this.isResettingFilters = false;
  }

  // Create Procedure Dialogue
  public showCreateProcedureModal() {
    this.router.navigate(['create-procedure'], {
      relativeTo: this.activatedRoute,
      queryParams: {
        siteOwnerId: this.selectedSite.siteOwner.id,
        allowCompulsoryCheckOnSiteForm: this.allowCompulsoryCheckOnSiteForm,
        allowCompulsoryCheckOffSiteForm: this.allowCompulsoryCheckOffSiteForm,
      },
    });
  }

  public viewProcedure(procedure: any) {
    this.router.navigate(['view-procedure', procedure.id], {
      relativeTo: this.activatedRoute,
    });
  }

  //
  // Edit Procedure
  //
  private editWorkOrderProcedure() {
    this.router.navigate(['edit-procedure', this.selectedProcedure.id], {
      relativeTo: this.activatedRoute,
      queryParams: {
        siteOwnerId: this.selectedSite.siteOwner.id,
        allowCompulsoryCheckOnSiteForm: this.allowCompulsoryCheckOnSiteForm,
        allowCompulsoryCheckOffSiteForm: this.allowCompulsoryCheckOffSiteForm,
      },
    });
  }

  //
  // Delete Procedure
  //

  private deleteWorkOrderProcedure() {
    Swal.fire({
      title: 'Delete Procedure?',
      text: 'You will not be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'confirm-danger',
      },
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.value) {
        this.procedureService.deleteWorkOrderProcedure(this.selectedProcedure.id).subscribe((data: any) => {
          this.getAllWorkerOrderProcedures();
          Swal.fire('Deleted!', 'Procedure has been removed.', 'success');
        });
      }
    });
  }
  public showCreateWorkOrderModalForOemProcedure(procedure: any) {
    this.selectedProcedure = procedure;
    this.showOEMProceduresModal = false;
    this.showCreateWorkOrderModal();
  }

  // Create WO from procedure
  private showCreateWorkOrderModal() {
    this.router.navigate(['create-work-order', this.selectedProcedure.id], {
      relativeTo: this.activatedRoute,
    });
  }

  //
  // Documents
  //
  private showViewAndDeleteDocumentsModal() {
    this.isViewProcedureDocumentsModalShown = true;
  }

  public showViewDocumentsModal(procedure) {
    this.selectedProcedure = procedure;
    this.isViewProcedureDocumentsModalShown = true;
  }

  public viewDocument(fileName: string): void {
    this.fileService.showFile(this.globals.fileFolder.workOrderProcedureFiles, fileName);
  }

  public deleteDocument(fileId): void {
    this.fileService.deleteFile(fileId);
    this.isViewProcedureDocumentsModalShown = false;
    Swal.fire({
      title: 'Delete RAMS Document?',
      text: 'Are you sure? This action cannot be reverted!',
      type: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'confirm-danger',
      },
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.value) {
        this.fileService.deleteFile(fileId).subscribe((data: any) => {
          this.getAllWorkerOrderProcedures();
          Swal.fire('Deleted!', 'Procedure RAMS Document has been deleted.', 'success');
        });
      }
    });
  }

  public onFileChange(event) {
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      this.selectedDocuments.push(file);
    }
  }

  private showUploadDocumentsModal() {
    this.selectedDocuments = [];
    this.isAddDocumentsToProcedureModalShown = true;
  }

  public onAddDocumentsSubmit(): void {
    this.saveInProgress = true;
    const procedure = {
      id: this.selectedProcedure.id,
      documents: this.selectedDocuments,
    };

    this.procedureService.addDocumentsToProcedure(procedure).subscribe(() => {
      this.saveInProgress = false;
      this.isAddDocumentsToProcedureModalShown = false;
      this.getAllWorkerOrderProcedures();
      Swal.fire('Uploaded!', 'Additional procedure documents have been uploaded.', 'success');
    });
  }

  public handleOemForSiteClick(event: any, oem: any): void {
    const isDelete = !event.target.checked;
    this.siteService.addDeleteOEMRelationShip(this.selectedSiteId, oem.maintenanceId, isDelete).subscribe((data) => {
      this.getOEMListBySite();
      const action = isDelete ? 'removed' : 'added';
      const siteAction = isDelete ? ' removed from ' : ' added to ';
      Swal.fire(`Procedures ${action}!`, `OEM Procedures for ${oem.oemName} have been${siteAction}${this.selectedSite.name}.`, 'success');
    });
  }

  public openOemProceduresModal(oem): void {
    this.selectedOem = oem;
    this.resetFilters();
    this.showOEMProceduresModal = true;
    this.resetPagination();
  }

  private getOEMProcedures(){
    this.procedureService.getAllWorkOrderProceduresByContractor(this.selectedOem.maintenanceId,this.pagination,this.selectedSort,this.filters).subscribe((data) => {
      this.oemProcedures = (data.body || []).map((procedure) => this.decorateProcedureCompetencies(procedure));
      this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
      this.isFilterLoading = false;
    });
  }
  public toggleSiteOemView(isOemView: boolean){
    this.isOEMView = isOemView;
    this.pageSizes = isOemView ? [10,15,20] : environment.pageSizes;
    this.resetPagination();
    this.resetFilters();
  }

  private getAllSiteForms() {
    const pagination: Pagination = {
      size: 10000,
      page: 0,
      totalRecords: 0
    };

    this.siteFormService.getAllBySite(this.selectedSiteId, pagination, ['siteForm.name']).subscribe((siteForms: any) => {
      this.siteFormsOptions.push({
        label: 'Select Site Form...',
        value: null,
      });
      siteForms.body.forEach((element) => {
        const item = {
          label: element.name,
          value: element.id,
        };
        this.siteFormsOptions.push(item);
      });
    });
  }

  private loadOemProcedureCompetencies(): void {
    this.procedureOemCompetencyService.getBySite(Number(this.selectedSiteId)).subscribe(
      (data) => {
        this.oemProcedureCompetencies = Array.isArray(data) ? data : [];
        this.rebuildOemProcedureCompetencyCards();
      },
      () => {
        Swal.fire('Error', 'Could not load OEM Procedure Competencies.', 'error');
      },
    );
  }

  private rebuildOemProcedureCompetencyCards(): void {
    this.oemProcedureCompetencyCards = this.oemProcedureCompetencies.map((competency) =>
      this.mapProcedureCompetency(competency, {}),
    );
  }

  public onAddOemProcedureCompetency(): void {
    const modalOptions: NgbModalOptions = { centered: true, size: 'lg', windowClass: 'procedure-competency-modal' };
    const modal = this.modalService.open(EditCompetenciesComponent, modalOptions);
    modal.componentInstance.procedure = {
      competencies: this.oemProcedureCompetencies,
    };
    modal.componentInstance.siteOwnerId = this.selectedSite && this.selectedSite.siteOwner ? this.selectedSite.siteOwner.id : undefined;
    modal.componentInstance.workerLevel = 'LEAD';
    modal.componentInstance.isOemProcedureMode = true;

    modal.result.then((result) => {
      if (result && result.competencyTypeId) {
        this.createOemProcedureCompetency(result);
      }
    }).catch(() => { /* modal dismissed */ });
  }

  private createOemProcedureCompetency(result: any): void {
    const body = {
      siteId: Number(this.selectedSiteId),
      competencyTypeId: result.competencyTypeId,
      manufacturer: result.manufacturer || undefined,
      models: Array.isArray(result.models) ? result.models : [],
      ratings: Array.isArray(result.ratings) ? result.ratings : [],
    };

    this.procedureOemCompetencyService.createProcedureOemCompetency(body).subscribe(
      (created) => {
        this.oemProcedureCompetencies = [...this.oemProcedureCompetencies, created];
        this.rebuildOemProcedureCompetencyCards();
        Swal.fire('Added!', 'OEM Procedure Competency has been added.', 'success');
      },
      () => {
        Swal.fire('Error', 'Could not create OEM Procedure Competency.', 'error');
      },
    );
  }

  public onOemProcedureCompetencyDelete(card: any): void {
    if (!card || !card.id) {
      return;
    }

    this.procedureOemCompetencyService.delete(Number(card.id)).subscribe(
      () => {
        this.oemProcedureCompetencies = this.oemProcedureCompetencies.filter((competency) => Number(competency.id) !== Number(card.id));
        this.rebuildOemProcedureCompetencyCards();
        Swal.fire('Deleted!', 'OEM Procedure Competency has been removed.', 'success');
      },
      () => {
        Swal.fire('Error', 'Could not delete OEM Procedure Competency.', 'error');
      },
    );
  }

  public showOEMSettingsModal(){
    const checkOnForm = this.selectedSite.oemProcedureCheckOnSiteForm ? this.selectedSite.oemProcedureCheckOnSiteForm.id : undefined;
    const checkOffForm = this.selectedSite.oemProcedureCheckOffSiteForm ? this.selectedSite.oemProcedureCheckOffSiteForm.id : undefined;

    this.updateSiteOEMSettingsForm.patchValue({
      minPartySize: this.selectedSite.oemProcedureMinimumPartySize,
      preapproved: this.selectedSite.oemProcedurePreapproved,
      siteFormCheckOn: checkOnForm,
      siteFormCheckOff: checkOffForm,
    });
    this.showOEMProcedureSettingsModal = true;

  }

  public submitOemProcedureSettings() {
    const values = this.updateSiteOEMSettingsForm.value;

    const body = {
      oemProcedureMinimumPartySize: values.minPartySize,
      oemProcedurePreapproved: values.preapproved,
      oemProcedureCheckOnSiteForm: values.siteFormCheckOn,
      oemProcedureCheckOffSiteForm: values.siteFormCheckOff,
    };
    this.siteService.updateSiteOemProcedureSettings(body, this.selectedSiteId).subscribe((data) => {
      this.showOEMProcedureSettingsModal = false;
      this.selectedSite = data;
      Swal.fire(`Settings saved!`, `OEM Procedure settings have been saved for ${this.selectedSite.name}.`, 'success');
    });
  }

  public hasCompetencyDetails(competency: any): boolean {
    return !!(competency && competency.oem);
  }

  private decorateProcedureCompetencies(procedure: any): any {
    const detailedCompetencies = this.mapProcedureCompetencies(procedure);

    return {
      ...procedure,
      detailedCompetencies,
    };
  }

  private mapProcedureCompetencies(procedure: any): any[] {
    return (procedure.competencies || []).map((competency) => this.mapProcedureCompetency(competency, procedure));
  }

  private mapProcedureCompetency(competency: any, procedure: any): any {
    const rawType = competency.competencyType || '';
    const isTurbine = rawType === 'TURBINE';
    const useProcedureLevelTurbineFields = isTurbine && this.shouldUseProcedureLevelTurbineFields(procedure, competency);
    const shortName = competency.competencyTypeShortName;
    const fullName = competency.competencyTypeName || '-';
    const modelItems = Array.isArray(competency.models)
      ? this.normalizeCompetencyDetailItems(competency.models)
      : this.normalizeCompetencyDetailItems(useProcedureLevelTurbineFields ? procedure.models : undefined);
    const ratingItems = Array.isArray(competency.ratings)
      ? this.normalizeCompetencyDetailItems(competency.ratings)
      : this.normalizeCompetencyDetailItems(useProcedureLevelTurbineFields ? procedure.ratings : undefined);

    return {
      id: competency.id || competency.competencyTypeId,
      type: COMPETENCY_CATEGORY_LABELS[rawType] || rawType || 'Competency',
      name: shortName || fullName,
      fullName,
      oem: competency.manufacturer || (useProcedureLevelTurbineFields ? procedure.manufacturer : undefined),
      model: this.buildCompetencyDetailPreview(modelItems),
      rating: this.buildCompetencyDetailPreview(ratingItems),
      applyToParty: !!competency.applyToParty,
    };
  }

  private shouldUseProcedureLevelTurbineFields(procedure: any, competency: any): boolean {
    const hasProcedureTurbineData = !!(procedure && (procedure.manufacturer || this.joinValues(procedure.models) || this.joinValues(procedure.ratings)));
    const hasCompetencySpecificTurbineData = !!(competency && (
      competency.manufacturer ||
      competency.oem ||
      competency.model ||
      competency.rating ||
      (Array.isArray(competency.models) && competency.models.length) ||
      (Array.isArray(competency.ratings) && competency.ratings.length)
    ));

    return hasProcedureTurbineData && !hasCompetencySpecificTurbineData;
  }

  private joinValues(values: any): string | undefined {
    if (!Array.isArray(values)) {
      return values || undefined;
    }

    const normalizedValues = values
      .map((value) => value != null ? String(value).trim() : '')
      .filter((value) => !!value);

    return normalizedValues.length ? normalizedValues.join(', ') : undefined;
  }
  private normalizeCompetencyDetailItems(value: any): string[] {
    const rawItems = Array.isArray(value) ? value : String(value || '').split(',');

    return rawItems
      .map((item) => item != null ? String(item).trim() : '')
      .filter((item) => !!item);
  }

  private buildCompetencyDetailPreview(items: string[]): string {
    if (!items.length) {
      return undefined;
    }

    const preview = items.slice(0, this.competencyDisplayItemLimit).join(', ');
    return items.length > this.competencyDisplayItemLimit ? `${preview}...` : preview;
  }
}
